module.exports = __webpack_public_path__ + "static/media/bloodBankAvatar.261fd00e.png";